import { startGame, stopGame } from './game.js';
import { loadMapsSdk } from './mapsSdk.js';
import { createLocationPicker } from './locationPicker.js';
import { initSearchUI } from './searchUI.js';
import { TOTAL_SITES } from './historicSites.js';
import { progress } from './historicProgress.js';
import { createLearningUI } from './learningUI.js';
import { courseState, SITE_BY_ID } from './learningData.js';
import { narration } from './narration.js';

const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const statusLine = document.getElementById('status-line');

if (!apiKey || apiKey === 'YOUR_KEY_HERE') {
  if (statusLine) {
    statusLine.textContent =
      '.env に VITE_GOOGLE_MAPS_API_KEY を設定してください (Map Tiles API を有効化)';
  }
  console.error('VITE_GOOGLE_MAPS_API_KEY is not set');
}

const titleEl = document.getElementById('title-screen');
const gameEl = document.getElementById('game-root');
let activeGame = null;
let picker = null;
const canFly = !!apiKey && apiKey !== 'YOUR_KEY_HERE';
const learning = createLearningUI({
  progress, canFly,
  onClose: () => { activeGame?.resume(); renderVisitProgress(); },
  onFlyCourse: (course, { restart }) => {
    const state = courseState(course, progress);
    const index = restart ? 0 : state.nextIndex;
    const target = SITE_BY_ID.get(course.siteIds[index]);
    if (!target) return;
    const departure = index === 0 ? course.departure : nearbyDeparture(target);
    onCityChosen({ ...departure, lookAt: target, course, restartCourse: restart,
      spawnAltitude: Math.max(250, target.elevationM + (target.ringAglM ?? 350) - (departure.elevation ?? 0)) });
  },
  onFlySite: site => onCityChosen({ ...nearbyDeparture(site), lookAt: site, targetSiteId: site.id, spawnAltitude: site.ringAglM ?? 350 }),
});
function nearbyDeparture(site) {
  return { name: site.name, lat: site.lat - 0.018, lng: site.lng, elevation: site.elevationM };
}
function openLearning(tab = 'courses', options) {
  activeGame?.pause();
  narration.stop();
  learning.open(tab, options);
}
for (const b of document.querySelectorAll('[data-learning-tab]')) b.addEventListener('click', () => openLearning(b.dataset.learningTab));
document.getElementById('narration-rate').addEventListener('change', e => narration.setRate(e.target.value));

// タイトル画面の「世界史スポット n / N 訪問済み」行とプログレスバー。
function renderVisitProgress() {
  const line = document.getElementById('visit-progress');
  const fill = document.getElementById('visit-progress-fill');
  const visited = progress.size;
  if (line) {
    line.textContent = visited === 0
      ? `世界史スポットを巡ろう / Fly through the glowing rings（全 ${TOTAL_SITES} 箇所）`
      : `世界史スポット ${visited} / ${TOTAL_SITES} 訪問済み / Historic sites visited`;
  }
  if (fill) fill.style.width = `${TOTAL_SITES ? (visited / TOTAL_SITES) * 100 : 0}%`;
  document.getElementById('review-count').textContent = `(${progress.reviewQueue({ limit: Infinity }).length})`;
}

function showTitle() {
  narration.stop();
  if (activeGame) {
    stopGame(activeGame);
    activeGame = null;
  }
  gameEl.hidden = true;
  titleEl.hidden = false;
  picker?.reset();
  renderVisitProgress();
}

function onCityChosen(options) {
  if (!canFly) return;
  if (activeGame) { stopGame(activeGame); activeGame = null; }
  titleEl.hidden = true;
  gameEl.hidden = false;
  try {
    activeGame = startGame({ ...options, apiKey, onOpenLearning: () => openLearning(), onHome: showTitle,
      onCourseComplete: course => openLearning('courses', { completion: course.id }) });
  } catch (error) {
    showTitle();
    statusLine.textContent = 'フライトを開始できませんでした。ページを再読み込みしてお試しください。';
    console.error('Flight start failed', error);
  }
}

window.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  if (learning.isOpen()) { e.preventDefault(); learning.close(); return; }
  if (!activeGame) return;
  // 解説モーダルが開いていれば、まず閉じて飛行を再開する。
  // もう一度 Escape を押すと従来どおり都市選択画面へ戻る。
  if (activeGame.handleEscape?.()) return;
  showTitle();
});

renderVisitProgress();

if (apiKey && apiKey !== 'YOUR_KEY_HERE') {
  // Pre-load the Maps SDK so the in-game minimap is ready when needed.
  loadMapsSdk(apiKey).catch((e) => {
    console.warn('Maps SDK preload failed:', e);
  });

  // 地域 → 国 → 都市 の階層選択ピッカー。
  picker = createLocationPicker({
    container: document.getElementById('location-picker'),
    leadEl: document.getElementById('picker-lead'),
    onChoose: onCityChosen,
  });

  // 都市名で検索して出発（Places オートコンプリート）。ピッカーの段階に関係なく常時表示。
  initSearchUI({
    apiKey,
    onCityChosen,
    onError: (msg) => { if (statusLine) statusLine.textContent = msg; },
  });
}
